import { ApiError } from "./api";
import type { RaffleConfig, RaffleOverview, RaffleRunResult } from "./raffle-types";

export type RaffleConfigInput = Pick<RaffleConfig, "enabled" | "registrationsEnabled" | "guildId" | "channelId" | "inviteUrl" | "nextWinnerCount">;

async function request<T>(path: string, init: RequestInit = {}): Promise<T> {
  const response = await fetch(path, {
    ...init,
    credentials: "include",
    headers: { "Content-Type": "application/json", ...init.headers },
  });
  const body: unknown = await response.json().catch(() => null);
  if (!response.ok) {
    const message = body && typeof body === "object" && "error" in body
      ? String(body.error) : `HTTP ${response.status}`;
    throw new ApiError(response.status, message);
  }
  return body as T;
}

export const getRaffle = () => request<RaffleOverview>("/api/raffle");
export const saveRaffleConfig = (config: RaffleConfigInput) => request<RaffleConfig>("/api/raffle/config", {
  method: "PUT", body: JSON.stringify(config),
});
export const retryRaffle = () => request<RaffleRunResult>("/api/raffle/retry", { method: "POST" });
export const createRaffleInvite = () => request<{ inviteUrl: string }>("/api/raffle/invite", { method: "POST" });
export const provisionRaffleDiscord = () => request<{ applicationId: string; guildId: string; channelId: string; commandId: string; interactionsEndpointUrl: string }>("/api/raffle/provision-discord", { method: "POST" });
